var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StandardSearchPageView',{ref:"tableWrap",attrs:{"rowKey":"id","columns":_vm.columns,"queryParams":_vm.queryParams,"request-promise":_vm.loadList,"enableSearch":false},scopedSlots:_vm._u([{key:"statusText",fn:function(ref){
var record = ref.record;
return [_vm._v(" "+_vm._s(_vm.getStatusText(record))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }